import Jamie from "@images/videos/jamie.png";
import JamieScreenshot from "@images/videos/jamie-screenshot.png";
import Michael from "@images/videos/michael.png";
import WhatToExpect from "@images/videos/what-to-expect.png";
import Commercial from "@images/videos/commercial.png";

export default {
    jamie: {
        videoUrl: "https://player.vimeo.com/video/1076748811?h=33d91b7a59&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=5847",
        transcriptPath: "/transcripts/patient-stories-jamie-transcript.html",
        videoPlaceholder: Jamie,
        videoPlaceholderAlt: "Watch video on Jamie's story",
        showISIModal: true,
        videoTitle: "Jamie's story",
        videoPlaceholderScreenshot: JamieScreenshot,
    },
    michael: {
        videoUrl: "https://player.vimeo.com/video/1076745911?h=1bc117b9cf&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        transcriptPath: "/transcripts/patient-stories-michael-transcript.html",
        videoPlaceholder: Michael,
        videoPlaceholderAlt: "Watch video on Michael's story",
        showISIModal: true,
        videoTitle: "Michael's story",
    },
    whatToExpect: {
        videoUrl: "https://player.vimeo.com/video/1204276435?h=421eabfeed&badge=0&autopause=0&player_id=0&app_id=58479",
        transcriptPath: "/transcripts/what-to-expect.html",
        videoPlaceholder: WhatToExpect,
        videoPlaceholderAlt: "Watch video on getting started with SUBLOCADE",
        showISIModal: false,
        videoTitle: "What to expect",
    },
    commercial: {
        videoUrl: "https://player.vimeo.com/video/1196087632?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        transcriptPath: "/transcripts/commercial.html",
        videoPlaceholder: Commercial,
        videoPlaceholderAlt: "",
        showISIModal: false,
        videoTitle: "SUBLOCADE Commercial",
    }
}
